<template>
  <div
    :class="['relative', extraClass, multiple && 'is-multiple-choice']"
  >
    <label
      v-if="label"
      class="mb-auto text-xs text-gray-600"
    >
      {{ label }}
    </label>

    <v-select
      :placeholder="placeholder"
      :options="options"
      :components="{OpenIndicator}"
      :value="value"
      :class="[
        error.length > 0 ? 'error' : '',
        'w-full mt-auto text-lg',
        'vs-select'
      ]"
      :reduce="reduce"
      :multiple="multiple"
      :searchable="false"
      @input="onInput"
    />
    <span v-if="error" class="px-2 py-px text-xs leading-none text-white bg-sw_error input-error">
      {{ error }}
    </span>
  </div>
</template>

<script>
import Select from '~brand-components/base/select/select'

export default Select.extend()
</script>

<style lang="scss">
.v-select {
  @apply text-lg;

  .vs__dropdown-toggle {
    @apply text-sw_text min-h-12.5 p-0 border border-sw_gray-300 rounded-none;
  }

  .vs__selected-options {
    @apply p-0;
  }

  .vs__selected {
    @apply h-12.5 border-0 rounded-none p-0 m-0 px-4;
  }

  .vs__search {
    @apply hidden;
  }

  .vs__actions {
    @apply p-0 pr-4;
  }

  .vs__open-indicator {
    display: block;
    width: 13px;
    height: 8px;
    background: url('~images/swiss/icons/arrow-down.svg') 0 0 / 13px 8px no-repeat;
  }

  .vs__clear {
    @apply hidden;
  }

  .vs__dropdown-menu {
    top: calc(100% + 10px);

    @apply shadow-6 px-0 border-0 rounded-none;
  }

  .vs__dropdown-option {
    @apply leading-none p-4 text-sw_text;
  }

  .vs__dropdown-option--highlight {
    @apply bg-sw_gray-700 text-white;
  }

  .vs__dropdown-option--selected {
    @apply bg-sw_primary text-white;
  }

  &.vs--open {
    .vs__dropdown-toggle {
      @apply shadow-1;
    }

    .vs__selected {
      @apply top-0 left-0;
    }
  }

  &.error {
    .vs__dropdown-toggle {
      @apply border-sw_error;
    }
  }
}

.is-multiple-choice {
  .v-select {
    .vs__selected {
      @apply h-8 p-2 mr-2 my-1;
    }
  }
}
</style>
